import DropTarget from "@uppy/drop-target";
import getDroppedFiles from "@uppy/utils/lib/getDroppedFiles";

/**
 * The Drop Target Handler plugin
 */

class DropTargetHandler extends DropTarget {
  static VERSION = "0.0.0";

  constructor(uppy, opts) {
    super(uppy, opts);
    this.id = this.opts.id || "DropTargetHandler";
    this.title = "Drop Target Handler";

    // Default options
    const defaultOpts = {};

    // Merge default options with the ones set by user
    this.opts = { ...defaultOpts, ...opts };
  }

  getJsonData = (event) => {
    try {
      return JSON.parse(event.dataTransfer.getData("application/json"));
    } catch (e) {}
  };

  handleDrop = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    clearTimeout(this.removeDragOverClassTimeout);

    // 2. Remove dragover class
    event.currentTarget.classList.remove("uppy-is-drag-over");
    this.setPluginState({ isDraggingOver: false });

    // 3. Add all dropped files
    this.uppy.log("[DropTarget] Files were dropped");

    const logDropError = (error) => {
      this.uppy.log(error, "error");
    };

    const jsonData = this.getJsonData(event);

    if (jsonData) {
      this.opts.onJsonDrop?.(event, jsonData);
    } else {
      const files = await getDroppedFiles(event.dataTransfer, { logDropError });
      this.addFiles(files);
      this.opts.onDrop?.(event, files); // DropTargetHandler: added files param
    }
  };
}

export default DropTargetHandler;
